import { BufferGeometry, PointsMaterial, AdditiveBlending, BufferAttribute, Points } from 'three';
import Experience from '../Experience.js';
import Repulsor from './Repulsor.js';

export default class Particles {
    constructor(amount, repulsion) {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.pointer = this.experience.pointer;

        this.amount = amount;

        this.setGeometry();
        this.setTexture();
        this.setMaterial();
        this.setMesh(amount);

        this.repulsor = repulsion ? new Repulsor(amount, repulsion) : null;
    }

    setGeometry() {
        this.geometry = new BufferGeometry();
    }

    setTexture() {
        this.texture = this.resources.items.particles;
    }

    setMaterial() {
        this.material = new PointsMaterial({
            size: 0.1,
            sizeAttenuation: true,
            // color: '#f7f1aa',
            map: this.texture,
            alphaMap: this.texture,
            transparent: true,
            // alphaTest: 0.5
            // depthTest: false
            depthWrite: false,
            blending: AdditiveBlending,
            vertexColors: true
        });
    }

    setMesh(amount) {
        const positions = new Float32Array(amount * 3);
        const colors = new Float32Array(amount * 3);

        for (let i = 0; i < amount * 3; i++) {
            positions[i] = (Math.random() - 0.5) * 20;
            colors[i] = Math.random();
        }

        // Where each particle lives when nothing is disturbing it. The drawn
        // buffer is a copy, so the cursor push is always measured from the rest
        // position and a particle can't be walked off into space by repeated
        // shoves.
        this.basePositions = positions;

        this.geometry.setAttribute('position', new BufferAttribute(positions.slice(), 3));
        this.geometry.setAttribute('color', new BufferAttribute(colors, 3));

        this.points = new Points(this.geometry, this.material);
        // The push carries particles outside the bounds computed at build time.
        this.points.frustumCulled = false;
        this.scene.add(this.points);
    }

    update(delta) {
        if (!this.repulsor || !this.points.visible) return;

        const wasIdle = this.repulsor.idle;
        this.repulsor.stepBuffer(delta, this.pointer, this.basePositions, this.amount);
        // Nothing moved and nothing was moving, so there's no buffer to reupload.
        if (wasIdle && this.repulsor.idle) return;

        const attribute = this.geometry.attributes.position;
        const drawn = attribute.array;
        const base = this.basePositions;
        const offsets = this.repulsor.offsets;

        for (let i = 0; i < base.length; i++) {
            drawn[i] = base[i] + offsets[i];
        }
        attribute.needsUpdate = true;
    }
}
